import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CEmail } from "../common/CEmail";
import { clientConfigFn } from "clientConfig";
export const SupportContactInformation = ({ IncludePlease = false, }) => {
    const clientConfig = clientConfigFn();
    const phoneNumber = clientConfig && clientConfig.supportPhoneNumber;
    const emailAddress = clientConfig && clientConfig.supportEmailAddress;
    if (phoneNumber !== "" && emailAddress !== "") {
        return (_jsxs("span", { children: [IncludePlease ? "Please contact" : "Contact", " support on", " ", phoneNumber, ", or alternatively email", " ", _jsx(CEmail, { email: emailAddress }), "."] }));
    }
    if (phoneNumber !== "") {
        return (_jsxs("span", { children: [IncludePlease ? "Please contact" : "Contact", " support on", " ", phoneNumber] }));
    }
    if (emailAddress !== "") {
        return (_jsxs("span", { children: [IncludePlease ? "Please contact" : "Contact", " support", " ", _jsx(CEmail, { email: emailAddress })] }));
    }
    return _jsxs("span", { children: [IncludePlease ? "Please contact" : "Contact", " support."] });
};
